interface Props {
  /** matriz 7×24 (dia da semana × hora). 0 = dom. */
  matriz: number[][];
}

const dias = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

export function PeakHoursHeatmap({ matriz }: Props) {
  const max = Math.max(1, ...matriz.flat());
  const corDe = (v: number) => {
    if (v === 0) return 'var(--bg-card)';
    const t = v / max;
    // 5 níveis discretos
    if (t < 0.2) return 'rgba(149,184,134,0.10)';
    if (t < 0.4) return 'rgba(149,184,134,0.22)';
    if (t < 0.6) return 'rgba(149,184,134,0.40)';
    if (t < 0.8) return 'rgba(149,184,134,0.65)';
    return 'var(--moss-300)';
  };

  return (
    <div className="flex flex-col gap-s2">
      <div className="grid grid-cols-[34px_1fr] gap-s2">
        <div />
        <div className="grid grid-cols-24 gap-[2px]" style={{ gridTemplateColumns: 'repeat(24,1fr)' }}>
          {Array.from({ length: 24 }).map((_, h) => (
            <span
              key={h}
              className="font-mono text-[9px] text-fg-3 text-center"
              style={{ visibility: h % 4 === 0 ? 'visible' : 'hidden' }}
            >
              {h}
            </span>
          ))}
        </div>
      </div>
      {matriz.map((linha, d) => (
        <div key={d} className="grid grid-cols-[34px_1fr] gap-s2 items-center">
          <span className="font-mono text-[10px] text-fg-3 text-right pr-s1">{dias[d]}</span>
          <div className="grid gap-[2px]" style={{ gridTemplateColumns: 'repeat(24,1fr)' }}>
            {linha.map((v, h) => (
              <div
                key={h}
                className="h-[18px] rounded-[3px] animate-fadeIn"
                style={{
                  background: corDe(v),
                  animationDelay: `${(d * 24 + h) * 6}ms`,
                  animationFillMode: 'both',
                }}
                title={`${dias[d]} ${h}h — ${v}`}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default PeakHoursHeatmap;
